var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultimg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 97,
    fill: "#F4F4F4",
    stroke: "#E4E6E7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 48,
    height: 48
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 48,
    height: 48,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 31C32.794 31 31 32.794 31 35V63C31 65.206 32.794 67 35 67H63C65.206 67 67 65.206 67 63V35C67 32.794 65.206 31 63 31H35ZM35 35H63L63.004 63H35V35ZM43 51L37 59H61L51 45L45 53L43 51ZM45 44C45 42.3431 43.6569 41 42 41C40.3431 41 39 42.3431 39 44C39 45.6569 40.3431 47 42 47C43.6569 47 45 45.6569 45 44Z",
    fill: "#2E3A59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultimg);
export default __webpack_public_path__ + "static/media/defaultimg.f62ddfdabd9f2ef452f23b2aa4840675.svg";
export { ForwardRef as ReactComponent };